import { Controller } from "@hotwired/stimulus"

// Submits its GET form once, `delay` ms after the form appears, while the page is in view. There's no loop here:
// the response renders a new form to check again, or none to stop. A hidden tab pauses the check; coming back makes
// it at once if it's due, or waits out the rest of the delay.
export default class extends Controller {
  static values = { delay: Number, held: Boolean }

  disconnect() {
    this.stop()
  }

  // Stimulus calls this as the controller connects and whenever the delay attribute changes. It and the end of a hold
  // are the two places that set the deadline.
  delayValueChanged() {
    this.dueAt = Date.now() + this.delayValue
    this.schedule()
  }

  resume() {
    if (document.visibilityState === "visible") {
      this.schedule()
    } else {
      this.stop()
    }
  }

  stop() {
    clearTimeout(this.timeout)
  }

  // Turbo runs one form submission at a time: starting a check would cancel a Save or a visit already under way,
  // and its page would never arrive. So another form's submission, or a visit, holds the check until it ends, and
  // nothing (not even coming back to the tab) makes one meanwhile.
  hold({ target }) {
    if (target !== this.element) this.heldValue = true
  }

  rearm({ target }) {
    if (target !== this.element) this.heldValue = false
  }

  // Once the hold ends, however it ends (rearm, or a morph that drops the attribute), the check waits a full delay
  // again, so it can't land while that page is still rendering.
  heldValueChanged(held) {
    if (held) {
      this.stop()
    } else {
      this.dueAt = Date.now() + this.delayValue
      this.schedule()
    }
  }

  schedule() {
    this.stop()
    if (this.heldValue || document.visibilityState !== "visible") return

    this.timeout = setTimeout(() => this.element.requestSubmit(), Math.max(this.dueAt - Date.now(), 0))
  }
}
